var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 682,
    viewBox: "-50 0 700 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Body / 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hands"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hands_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.335 483.374C494.335 483.374 467.397 486.668 462.269 498.392C447.603 531.932 477.993 591.89 477.993 591.89C477.993 591.89 465.117 584.252 462.555 590.932C461.413 593.906 458.829 617.66 507.071 619.258C512.193 619.428 524.515 609.296 524.515 609.296C524.515 609.296 515.531 625.978 529.287 629.256C529.287 629.256 551.457 596.954 551.797 589.768C552.135 582.578 545.019 546.194 541.173 538.848C537.325 531.498 494.335 483.374 494.335 483.374ZM130.023 545.883C125.351 532.459 120.141 521.383 120.141 521.383L50.6194 524.669C44.1959 542.468 43.108 552.715 41.7003 565.975C41.4718 568.127 41.2349 570.359 40.9654 572.715C39.3694 586.677 39.2594 600.719 44.6874 619.403C48.1774 631.409 51.9014 641.615 53.8414 641.185C58.7274 640.103 58.9114 633.985 58.9114 633.985L56.6094 622.615L55.5654 611.515C55.5654 611.515 72.9214 660.661 74.3914 660.389C79.5914 659.431 80.4194 650.819 80.4194 650.819C80.4194 650.819 85.8554 667.781 88.5934 667.167C95.5574 665.601 94.8974 657.747 94.8974 657.747C94.8974 657.747 97.0954 659.623 98.7834 659.149C105.092 657.372 104.901 646.473 104.789 640.09C104.78 639.581 104.772 639.101 104.767 638.657C104.767 638.657 101.975 618.565 102.547 612.371C105.451 580.823 110.46 573.316 113.206 569.201C113.466 568.812 113.706 568.453 113.921 568.107C118.231 570.968 119.827 575.867 121.521 581.068C122.754 584.85 124.038 588.791 126.455 592.225C133.809 602.675 154.327 612.545 142.857 588.609C136.487 575.316 134.904 567.138 133.434 559.546C132.572 555.095 131.75 550.845 130.023 545.883Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    opacity: 0.147205,
    d: "M487.846 526.703C487.846 526.703 494.616 551.571 517.848 559.321C525.972 562.029 523.942 594.013 543.854 590.187",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sweater"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sweater_2",
    d: "M537.937 500.287L450.897 548.727L429.497 507.287L430.037 451.967H303.017L288.937 451.947H164.057L162.197 383.829L139.537 520.467L40.0574 525.167C40.0574 525.167 38.0974 382.867 57.0374 300.547C69.0974 248.107 128.017 150.667 183.817 117.167C192.737 111.807 204.577 108.047 217.797 105.447C222.617 104.487 227.617 103.687 232.717 103.027C283.197 96.487 344.297 103.047 344.297 103.047C349.137 104.807 353.677 106.547 357.917 108.307C360.497 109.367 362.957 110.427 365.317 111.487C368.557 112.947 371.597 114.387 374.457 115.847L374.617 115.927C415.097 136.467 420.877 157.447 433.637 183.829C449.997 217.587 466.937 321.287 466.937 321.287L537.937 500.287Z",
    fill: "#2F2F3D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shirt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shirt_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.81 107.644L361.76 108.002L355.04 67.3198L340.7 66.6398L319.06 99.8198L297.78 64.5798L243.94 62.0018L228.66 102.682L259.348 103.908L324.301 193.923L352.81 107.644Z",
    fill: "#FCBDA4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shirt shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shirt shadow_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.67 74.5556L268.184 112.76L309.752 98.5136L283.67 74.5556ZM350.647 79.7494L325.705 100.269L359.081 115.359L350.647 79.7494Z",
    fill: "#EA847A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    opacity: 0.201218,
    d: "M160.382 400.09L173.518 305.366L214.2 242.1",
    stroke: "black",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    opacity: 0.202962,
    d: "M430.038 451.961L438.732 301.639",
    stroke: "black",
    strokeWidth: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.abdb69c0.svg";
export { ForwardRef as ReactComponent };